import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const PremiumFeatures = () => {
    const [hoveredFeature, setHoveredFeature] = useState(null);
    
    const features = [
      {
        icon: 'fa-file-import',
        title: 'Bulk Checking',
        description: 'Check up to 1,000 accounts simultaneously with CSV import/export',
      },
      {
        icon: 'fa-check-double',
        title: 'Live Verification',
        description: 'Automatically verify accounts against Mojang servers',
      },
      {
        icon: 'fa-envelope',
        title: 'Email Matching',
        description: 'Find associated email addresses for complete account recovery',
      },
      {
        icon: 'fa-database',
        title: 'Extended Database',
        description: 'Access our premium database with 7M+ additional accounts',
      },
    ];

    const navigate = useNavigate();

    const handleUpgradeClick = () => {
        navigate("/account", { state: { scrollTo: "plans" } });
    }
  
    return (
      <div className="bg-dark-600 rounded-2xl p-6 mb-8 gradient-border relative overflow-hidden group hover:shadow-lg transition-medium transform-gpu hover:scale-[1.005]">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <h3 className="font-bold text-lg mb-2 flex items-center">
              <i className="fas fa-crown mr-2 text-accent-yellow group-hover:rotate-12 transition-medium"></i>
              Premium Account Checker Features
            </h3>
            <p className="text-gray-400 text-sm max-w-2xl group-hover:text-gray-300 transition-medium">
              Upgrade to VIP to access advanced features including bulk checking, automatic verification, email checking, and more.
            </p>
          </div>
          <div className="flex gap-3">
            <button onClick={handleUpgradeClick} className="px-5 py-2.5 bg-dark-500 hover:bg-dark-400 rounded-xl text-sm font-medium transition-medium transform-gpu hover:-translate-y-0.5 hover:shadow-md active:translate-y-0 active:shadow-inner">
              Learn More
            </button>
            <button onClick={handleUpgradeClick} className="px-5 py-2.5 bg-gradient-to-r from-accent-yellow to-accent-orange text-dark-800 rounded-xl text-sm font-medium transition-medium transform-gpu hover:-translate-y-0.5 hover:shadow-md hover:shadow-accent-yellow/20 active:translate-y-0 active:shadow-inner">
              <i className="fas fa-crown mr-1.5"></i>
              Upgrade to VIP
            </button>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mt-6">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className={`bg-dark-500 rounded-lg p-3 transition-medium transform-gpu cursor-default ${
                hoveredFeature === index ? 'scale-105 shadow-md' : 'hover:bg-dark-400 hover:-translate-y-0.5'
              }`}
              onMouseEnter={() => setHoveredFeature(index)}
              onMouseLeave={() => setHoveredFeature(null)}
            >
              <div className="flex items-center mb-2">
                <div className={`w-8 h-8 rounded-lg bg-accent-yellow bg-opacity-20 flex items-center justify-center mr-2 transition-medium transform-gpu ${
                  hoveredFeature === index ? 'rotate-12 scale-110' : ''
                }`}>
                  <i className={`fas ${feature.icon} text-accent-yellow`}></i>
                </div>
                <h4 className="font-medium text-sm">{feature.title}</h4>
              </div>
              <p className="text-xs text-gray-400">{feature.description}</p>
            </div>
          ))}
        </div>
        
        {/* Enhanced glow effects */}
        <div className="absolute -right-12 -bottom-12 w-48 h-48 bg-accent-yellow opacity-5 group-hover:opacity-10 group-hover:blur-2xl transition-medium rounded-full blur-xl"></div>
        <div className="absolute -left-12 -top-12 w-36 h-36 bg-accent-orange opacity-0 group-hover:opacity-5 group-hover:blur-2xl transition-medium rounded-full blur-xl"></div>
      </div>
    );
  };

export default PremiumFeatures;